export default {
  roles: {
    admin: "Administrator",
    manager: "Manager",
    teamleader: "Team leader",
    user: "User",
  },
};
